import { FormControl, Input, InputLabel, MenuItem, Select } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { changeSelectedSupplier, getSelectedSupplier } from 'features/settings/settingsSlice';
import { useSuppliers, useThunkDispatch } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 150,
    },
  }),
);

const SupplierSelection = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const suppliers = useSuppliers();
  const dispatch = useThunkDispatch();
  const selectedSupplier = useSelector(getSelectedSupplier);

  const handleSuppliersChange = (event: React.ChangeEvent<{ value: any }>) => {
    dispatch(
      changeSelectedSupplier(suppliers[suppliers.map(s => s.name).indexOf(event.target.value)]),
    );
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor="select-supplier">{t('suppliers')}</InputLabel>
      <Select
        value={selectedSupplier?.name ?? ''}
        onChange={handleSuppliersChange}
        input={<Input id="select-supplier" />}
      >
        <MenuItem value={undefined}>All</MenuItem>
        {suppliers.map(({ name }) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SupplierSelection;
